import React, { useRef, useState } from "react";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import Popover from "../../../Layouts/Popover/Popover";

const shortcuts = [
  { keys: "Esc", action: "Deselect / Close edit bar" },
  { keys: "Double Click", action: "Open Editbar" },
  { keys: "← / ↑ / → / ↓", action: "Move selected item" },
  { keys: "Shift + ← / ↑ / → / ↓", action: "Resize selected item" },
  { keys: "Shift + Delete", action: "Delete selected item(s)" },
  { keys: "Ctrl + E", action: "Edit selected item(s)" },
  { keys: "Ctrl + D", action: "Duplicate selected item(s)" },
  { keys: "Ctrl + C", action: "Copy selected item(s)" },
  { keys: "Ctrl + V", action: "Paste" },
  { keys: "Ctrl + X", action: "Cut" },
  { keys: "L", action: "Align Left (multi)" },
  { keys: "T", action: "Align Top (multi)" },
  { keys: "H", action: "Distribute Horizontally (multi)" },
  { keys: "V", action: "Distribute Vertically (multi)" }
];

const KeyboardShortcutsInfoPopover = () => {
  const [isPopoverOpen, setPopoverOpen] = useState(false);
  const [anchorPoint, setAnchorPoint] = useState({ x: 0, y: 0 });
  const iconRef = useRef();

  const handleMouseEnter = () => {
    const rect = iconRef.current.getBoundingClientRect();
    setAnchorPoint({ x: rect.left - 200, y: rect.top - 20 });
    setPopoverOpen(true);
  };

  const handleMouseLeave = () => {
    setPopoverOpen(false);
  };

  const midpoint = Math.ceil(shortcuts.length / 2);
  const column1 = shortcuts.slice(0, midpoint);
  const column2 = shortcuts.slice(midpoint);

  const renderColumn = (items) => (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "8px" }}>
      {items.map((item, idx) => (
        <div
          key={idx}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <div style={{ flex: 1, textAlign: "left", fontSize: "12px", color: "#333" }}>{item.action}</div>
          <div
            style={{
              fontFamily: "monospace",
              backgroundColor: "#f5f5f5",
              padding: "3px 6px",
              borderRadius: "6px",
              border: "1px solid #ddd",
              fontSize: "11px",
              textAlign: "right",
              whiteSpace: "nowrap",
              marginLeft: "16px",
              minWidth: "130px"
            }}
          >
            {item.keys}
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div
      ref={iconRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={"d_flex align_center cursor_pointer"}
    >
      <MaterialIcon name={"keyboard"} />
      {isPopoverOpen && (
        <Popover anchorPoint={anchorPoint} onClose={() => setPopoverOpen(false)}>
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "12px",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
              padding: "24px",
              width: "720px",
              fontFamily: "system-ui, sans-serif",
              fontSize: "12px",
              lineHeight: "1.5",
              color: "#222"
            }}
          >
            <h4 className={"d_flex align_center mb_3 gap_2 font_weight_semibold border_bottom pb_1"}>
              <MaterialIcon name={"keyboard"} /> Keyboard Shortcuts
            </h4>

            <div style={{ display: "flex", gap: "32px" }}>
              {renderColumn(column1)}
              {renderColumn(column2)}
            </div>
          </div>
        </Popover>
      )}
    </div>
  );
};

export default KeyboardShortcutsInfoPopover;
